module.exports = __webpack_public_path__ + "img/server.e52e1704.svg";